import { CUSTOM_ELEMENTS_SCHEMA, Injector, NO_ERRORS_SCHEMA, NgModule } from '@angular/core';
import { createCustomElement } from '@angular/elements';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CurrencyPipe, DatePipe, DecimalPipe } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi, withXhr } from '@angular/common/http';

// components
import { ModalComponent } from './modal/modal.component';
import { SaleItemComponent } from './sale-item.component';
import { PaymentPlanTextComponent } from 'src/sale-item/payment-plan-text/payment-plan-text.component';
import { PaymentAmountOptionsComponent } from './payment-amount-options/payment-amount-options.component';
import {
  SeFeIconModule, seFeIconCalendar, seFeIconFlag, seFeIconPlusCircleOutline,
  seFeIconQuestionCircle, seFeIconRemove,
  seFeIconCalendarToday,
  seFeIconDollar
} from 'se-fe-icon';
import { SeFeFormFieldSelectModule } from 'se-fe-form-field-select';
import { SeFePositionModule } from 'se-fe-position';
import { SeFePopoverModule } from 'se-fe-popover';
import { SeFeAuthSupportModule } from 'se-fe-auth-support';
import { environment } from 'src/environments/environment';
import { SeFeApiModule } from 'se-fe-api';
import { SeFeAlertModule } from 'se-fe-alert';
import { SeFeButtonModule } from 'se-fe-button';
import { SeFeTooltipModule } from 'se-fe-tooltip';
import { PriceVariationComponent } from './payment-amount-options/price-variation-detail/price-variation.component';
import { SeFeBlockModule } from 'se-fe-block';
import { SeFeFormFieldModule } from 'se-fe-form-field';
import { SeFeFormFieldTextModule } from 'se-fe-form-field-text';
import { SeFeDatepickerModule } from 'se-fe-datepicker';
import {SeFeFormFieldMultiselectModule} from 'se-fe-form-field-multiselect';
import { SeFeFormFieldOptionsModule } from 'se-fe-form-field-options';

@NgModule({ declarations: [
        ModalComponent,
        PaymentPlanTextComponent,
        PaymentAmountOptionsComponent,
        SaleItemComponent,
        PriceVariationComponent
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA], imports: [BrowserModule,
        FormsModule,
        ReactiveFormsModule,
        SeFeAlertModule,
        SeFeFormFieldSelectModule,
        SeFeApiModule.forRoot({
            domainEnvironments: environment.domainEnvironments
        }),
        SeFeAuthSupportModule.forRoot(environment),
        SeFePopoverModule,
        SeFePositionModule,
        SeFeIconModule.include([
            seFeIconQuestionCircle,
            seFeIconCalendar,
            seFeIconFlag,
            seFeIconPlusCircleOutline,
            seFeIconRemove,
            seFeIconCalendarToday,
            seFeIconDollar
        ]),
        SeFeButtonModule,
        SeFePopoverModule,
        SeFeApiModule,
        SeFeTooltipModule,
        SeFeBlockModule,
        SeFeFormFieldModule,
        SeFeFormFieldTextModule,
        SeFeFormFieldOptionsModule,
        SeFeDatepickerModule,
        SeFeFormFieldMultiselectModule], providers: [
        CurrencyPipe,
        DecimalPipe,
        DatePipe,
        provideHttpClient(withXhr(), withInterceptorsFromDi())
    ] })

export class SaleItemModule {
  constructor(private injector: Injector) {}

  public ngDoBootstrap() {
    const el = createCustomElement(SaleItemComponent, { injector: this.injector });
    if (!customElements.get('sale-item-element')) {
      customElements.define('sale-item-element', el);
    }
  }
}
